// Packing items live inside their list. Every default-seeded copy shares the 2023 template's item _ids, so normalising
// PackingListItem by _id merged items across lists and trips (a tick on one list showing on another). Both Apollo
// clients (index.tsx for the app, graphql/client.ts) spread these in; the list's items are replaced whole.
export const packingTypePolicies = {
	PackingListItem: {
		keyFields: false as const,
	},
	PackingList: {
		fields: {
			items: { merge: false },
		},
	},
};
